/* pb-galerie.js — comportements de l'accueil « Galerie des maisons », lot 1 (onglets, bande des maisons). Sans bibliothèque, idempotent (chargé par deux sections).
   Porté de la maquette du 15/10/2026. Rien ici ne touche à l'en-tête, au pied, au panier ni au bandeau cookies. */
(function () {
  if (window.__pbgInit) return;
  window.__pbgInit = 1;
  var d = document;

  function onglets(g) {
    var tabs = [].slice.call(g.querySelectorAll('.pbg-onglet'));
    if (!tabs.length) return;
    function choisir(t) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var p = d.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { choisir(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          choisir(n); n.focus(); e.preventDefault();
        }
      });
    });
  }

  function mur(m) {
    var piste = m.querySelector('.pbg-mur__piste');
    var vue = m.querySelector('.pbg-mur__vue');
    if (!piste || !vue) return;
    var vit = +(m.getAttribute('data-vitesse') || 30);
    /* Durée au réel : largeur mesurée de la piste / vitesse (30 px/s). La valeur Liquid du serveur sert de repli avant mesure. */
    function duree() {
      var w = piste.getBoundingClientRect().width;
      if (w > 0) {
        var s = (w / vit).toFixed(2) + 's';
        m.style.setProperty('--pbg-dur-tel', s);
        m.style.setProperty('--pbg-dur-ordi', s);
        m.setAttribute('data-tour', s);
      }
    }
    duree();
    addEventListener('load', duree);
    addEventListener('resize', duree, { passive: true });
    /* Pause : doigt posé (reprise 2 s après qu'il se lève), hors écran, et commande ‖ de l'utilisateur. Souris : pause au survol, en CSS. */
    var t = null, hors = false;
    function maj() { m.classList.toggle('en-pause', hors || m.classList.contains('est-touche')); }
    vue.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      clearTimeout(t); m.classList.add('est-touche'); maj();
    }, { passive: true });
    function relache() {
      clearTimeout(t);
      t = setTimeout(function () { m.classList.remove('est-touche'); maj(); }, 2000);
    }
    vue.addEventListener('pointerup', relache, { passive: true });
    vue.addEventListener('pointercancel', relache, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { hors = !e[0].isIntersecting; maj(); }).observe(m);
    }
    var b = m.querySelector('.pbg-mur__pause');
    if (b) {
      var lire = b.getAttribute('data-lire'), pause = b.getAttribute('data-pause');
      b.addEventListener('click', function () {
        var p = m.classList.toggle('en-pause-demande');
        b.setAttribute('aria-pressed', p ? 'true' : 'false');
        var sr = b.querySelector('.pbg-sr'); if (sr) sr.textContent = p ? lire : pause;
      });
    }
  }

  function init() {
    [].slice.call(d.querySelectorAll('[data-pbg-onglets]')).forEach(onglets);
    [].slice.call(d.querySelectorAll('.pbg-mur')).forEach(mur);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();

/* 15/10/2026 — téléphone : le titre s'efface quand les flacons apparaissent (t ≥ 5,2 s) et revient à chaque début de boucle. */
(function(){
  if (!window.matchMedia || !matchMedia('(max-width:749px)').matches) return;
  document.querySelectorAll('.pbg-ouv').forEach(function(o){
    var v = o.querySelector('.pbg-ouv__video'); if (!v) return;
    var seuil = parseFloat(o.getAttribute('data-fondu')) || 5.2;
    v.addEventListener('timeupdate', function(){ o.classList.toggle('pbg-ouv--libre', v.currentTime >= seuil); });
  });
})();

/* 16/10/2026 — DÉFILÉ CONTINU des rangées d'images (Benoit : « doit bouger tout seul de droite à gauche et en continuité »).
   Toute rangée [data-pbg-defile] avance seule, sans fin (copies aria-hidden + inert), à vitesse constante (data-vitesse, px/s).
   Arrêt : souris posée, focus clavier (la carte focalisée est ramenée à l'écran), doigt posé puis 2,5 s après, hors écran, onglet caché,
   onglet du navigateur en arrière-plan, bouton ‖ (WCAG 2.2.2). Le doigt ou le pavé tactile font glisser la rangée (avec élan) ; un glissé
   n'ouvre pas la fiche. Animations réduites : aucune avance, rangée simplement balayable. Images de la rangée chargées dès qu'elle approche. */
(function () {
  if (window.__pbgDefile) return;
  window.__pbgDefile = 1;
  var d = document;
  var reduit = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  function mod(a, b) { return ((a % b) + b) % b; }

  function defile(el) {
    if (el.__pbgD) return; el.__pbgD = 1;
    var vue = el.querySelector('.pbg-defile__vue'), piste = el.querySelector('.pbg-defile__piste');
    if (!vue || !piste) return;
    var items = [].slice.call(piste.children);
    if (reduit || items.length < 2) { el.classList.add('est-libre'); return; }
    el.classList.add('est-anime');
    var vit = +(el.getAttribute('data-vitesse') || 28);
    var W = 0, off = 0, last = 0, raf = 0, visible = false, charge = false;
    var survol = false, focus = false, doigt = false, demande = false, repos = 0, v = 0, largeur = 0;
    var clones = [];

    function peindre() { piste.style.transform = 'translate3d(' + (-off).toFixed(2) + 'px,0,0)'; }
    function mesurer() {
      if (!el.offsetParent && getComputedStyle(el).position !== 'fixed') return false;
      clones.forEach(function (c) { c.parentNode && c.parentNode.removeChild(c); });
      clones = [];
      var gap = parseFloat(getComputedStyle(piste).columnGap) || 0;
      var a = items[0], b = items[items.length - 1];
      W = b.offsetLeft + b.offsetWidth - a.offsetLeft + gap;
      largeur = vue.clientWidth;
      if (!(W > 0)) { W = 0; return false; }
      var k = Math.ceil(largeur / W) + 1;
      for (var r = 0; r < k; r++) items.forEach(function (it) {
        var c = it.cloneNode(true);
        c.setAttribute('aria-hidden', 'true'); c.setAttribute('inert', ''); c.removeAttribute('id');
        if (c.tagName === 'A' || c.tagName === 'BUTTON') c.tabIndex = -1;
        [].forEach.call(c.querySelectorAll('a,button,[tabindex]'), function (x) { x.tabIndex = -1; });
        [].forEach.call(c.querySelectorAll('[id]'), function (x) { x.removeAttribute('id'); });
        [].forEach.call(c.querySelectorAll('img'), function (i) { i.loading = 'eager'; i.removeAttribute('fetchpriority'); });
        piste.appendChild(c); clones.push(c);
      });
      off = mod(off, W); peindre();
      return true;
    }
    function charger() {
      if (charge) return; charge = true;
      [].forEach.call(piste.querySelectorAll('img[loading="lazy"]'), function (i) { i.loading = 'eager'; });
    }
    function tick(t) {
      raf = 0;
      if (!visible || !W) { last = 0; return; }
      var dt = last ? Math.min(t - last, 64) : 0; last = t;
      if (!doigt) {
        if (Math.abs(v) > 0.02) { off += v * dt; v *= Math.pow(0.94, dt / 16.67); }
        else if (!survol && !focus && !demande && t >= repos) { v = 0; off += vit * dt / 1000; }
        off = mod(off, W); peindre();
      }
      raf = requestAnimationFrame(tick);
    }
    function lancer() { if (!raf && visible) { last = 0; raf = requestAnimationFrame(tick); } }
    function etat(on) {
      visible = on && !d.hidden;
      if (visible) { charger(); if (!W) mesurer(); lancer(); }
    }

    /* souris : pause au survol (pointerType « mouse » seulement : un doigt sur iPhone émule un survol qui ne se lève jamais) */
    vue.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') survol = true; });
    vue.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { survol = false; repos = 0; } });
    /* glisser au doigt, au stylet ou à la souris */
    var xPrec = 0, tPrec = 0, bouge = 0, pid = null;
    vue.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (!W) mesurer();
      doigt = true; pid = e.pointerId; xPrec = e.clientX; tPrec = e.timeStamp; bouge = 0; v = 0;
    }, { passive: true });
    vue.addEventListener('pointermove', function (e) {
      if (!doigt || e.pointerId !== pid || !W) return;
      var dx = e.clientX - xPrec, dt = e.timeStamp - tPrec;
      off = mod(off - dx, W); bouge += Math.abs(dx);
      if (dt > 0) v = Math.max(-2.2, Math.min(2.2, -dx / dt));
      xPrec = e.clientX; tPrec = e.timeStamp;
      if (bouge > 6 && vue.setPointerCapture) { try { if (!vue.hasPointerCapture(pid)) vue.setPointerCapture(pid); } catch (_) {} }
      peindre();
    }, { passive: true });
    function fin(e, annule) {
      if (!doigt || (e && e.pointerId !== pid)) return;
      doigt = false; pid = null;
      if (annule || e.timeStamp - tPrec > 80) v = 0;
      repos = performance.now() + 2500; lancer();
    }
    vue.addEventListener('pointerup', function (e) { fin(e, false); });
    vue.addEventListener('pointercancel', function (e) { fin(e, true); });
    vue.addEventListener('click', function (e) { if (bouge > 6) { e.preventDefault(); e.stopPropagation(); } bouge = 0; }, true);
    vue.addEventListener('dragstart', function (e) { e.preventDefault(); });
    /* pavé tactile / molette horizontale */
    vue.addEventListener('wheel', function (e) {
      if (!W || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault(); v = 0; off = mod(off + e.deltaX, W); peindre(); repos = performance.now() + 2500;
    }, { passive: false });
    /* clavier : la carte focalisée revient à l'écran, la rangée s'arrête tant que le focus y reste */
    el.addEventListener('focusin', function (e) {
      focus = true; if (!W) mesurer();
      var it = e.target; while (it && it.parentNode !== piste) it = it.parentNode;
      if (!it || !W) return;
      var x = it.offsetLeft - off;
      if (x < 0 || x + it.offsetWidth > vue.clientWidth) { v = 0; off = mod(it.offsetLeft - 16, W); peindre(); }
      vue.scrollLeft = 0;
    });
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) focus = false; });
    vue.addEventListener('scroll', function () { if (vue.scrollLeft) vue.scrollLeft = 0; }, { passive: true });
    /* bouton ‖ / ▶ */
    var pied = el.nextElementSibling;
    var b = el.querySelector('.pbg-defile__pause') || (pied && pied.classList.contains('pbg-defile__pied') ? pied.querySelector('.pbg-defile__pause') : null);
    if (b) b.addEventListener('click', function () {
      demande = !demande; el.classList.toggle('en-pause-demande', demande);
      b.setAttribute('aria-pressed', demande ? 'true' : 'false');
      var sr = b.querySelector('.pbg-sr'); if (sr) sr.textContent = demande ? b.getAttribute('data-lire') : b.getAttribute('data-pause');
    });
    /* visibilité : à l'écran (marge 200 px), onglet affiché, page au premier plan */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { etat(en[en.length - 1].isIntersecting); }, { rootMargin: '200px 0px' }).observe(el);
    } else { etat(true); }
    d.addEventListener('visibilitychange', function () { if (d.hidden) { visible = false; } else if (el.getBoundingClientRect().height) { etat(true); } });
    var tr = 0;
    addEventListener('resize', function () {
      clearTimeout(tr);
      tr = setTimeout(function () { if (vue.clientWidth !== largeur) { W = 0; if (visible) mesurer(); } }, 200);
    }, { passive: true });
    addEventListener('load', function () { if (visible) mesurer(); });
  }

  function init() { [].forEach.call(d.querySelectorAll('[data-pbg-defile]'), defile); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();

/* 16/10/2026 — lien de menu « CONTACT & CONCIERGERIE » : arrivée sur l'accueil avec #conciergerie (ou clic sur le lien depuis l'accueil) = la conciergerie s'ouvre. */
(function () {
  function ouvrir() {
    if (location.hash !== '#conciergerie') return;
    var c = document.getElementById('conciergerie'); if (!c) return;
    var b = c.querySelector('details'); if (b && !b.open) b.open = true;
    setTimeout(function () { c.scrollIntoView({ block: 'start' }); }, 80);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ouvrir); else ouvrir();
  addEventListener('hashchange', ouvrir);
})();

/* 16/10/2026 — DIAPORAMA [data-pbg-diapo] (Automne · Hiver). Benoit : « je veux que tu affiche un première image puis 3s après la 2eme, etc…
   avec des effets de transition sublime, je ne veux pas un simple carrousel qui bouge tout doucement ».
   UN visuel à la fois : 3 s d'affichage (data-duree), puis transition d'1 s, en rotation de 3 effets qui n'animent QUE transform et opacity
   (Safari iPhone anime filter / clip-path / mask sur le fil principal) : fondu par l'ombre (l'ancien s'éteint vers #120F0C, PUIS le nouveau émerge),
   rideau or (enveloppe qui se translate, liseré or sur le bord), ouverture du coffret (l'ancien se fend en deux moitiés qui s'écartent). Le segment du visuel en cours se remplit pendant les 3 s ; sa fin
   (animationend) déclenche le suivant : la pause CSS gèle donc le temps exactement. Jamais de blanc : le visuel suivant n'entre qu'une fois
   chargé et décodé ; le suivant et le précédent sont préchargés. Pause : souris posée, doigt posé, focus clavier, hors écran, onglet masqué,
   bouton ‖ (WCAG 2.2.2), éditeur de thème. Doigt : balayage gauche/droite (le défilement vertical de la page reste libre). Clavier : ← →.
   v2 (16/10, 17 h) : le pied (prix en couches + bouton « Découvrir ») est FIXE, hors des visuels : seuls le lien (href), le libellé accessible et le prix
   (fondu croisé sans trou) changent, au milieu de la transition. Animations réduites : aucune avance automatique, aucun effet, navigation par les segments.
   Sans bibliothèque, idempotent. */
(function () {
  if (window.__pbgDiapoInit) return;
  window.__pbgDiapoInit = 1;
  var d = document;
  var TRANS = 1000;
  var EFFETS = ['fondu', 'rideau', 'ouverture'];
  var reduit = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  function deux(n) { return (n < 10 ? '0' : '') + n; }

  function diapo(el) {
    if (el.__pbgDiapo) return; el.__pbgDiapo = 1;
    var piste = el.querySelector('.pbg-diapo__piste');
    var ds = [].slice.call(el.querySelectorAll('.pbg-diapo__d'));
    var boite = el.querySelector('.pbg-diapo__segs');
    var annonce = el.querySelector('.pbg-diapo__annonce');
    var racine = el.closest('section') || el.parentNode;
    var compte = racine.querySelector('.pbg-diapo__compte');
    var bouton = racine.querySelector('[data-pbg-diapo-pause]');
    var N = ds.length;
    if (!piste || !N) return;
    var en = (d.documentElement.lang || 'fr').slice(0, 2).toLowerCase() !== 'fr';
    var duree = +(el.getAttribute('data-duree') || 3000);
    el.style.setProperty('--pbg-diapo-duree', duree + 'ms');
    el.style.setProperty('--pbg-diapo-trans', TRANS + 'ms');
    if (reduit) el.classList.add('est-reduit');
    var cur = Math.max(0, ds.findIndex ? ds.findIndex(function (s) { return s.classList.contains('est-actif'); }) : 0);
    var nb = 0, sortant = null, entrant = null, minuterie = 0, jeton = 0, tMilieu = 0, tPrix = 0, moities = null;
    var cta = racine.querySelector('[data-pbg-diapo-cta]');
    var couches = [].slice.call(racine.querySelectorAll('.pbg-diapo__l'));
    var ariaCta = cta ? (cta.getAttribute('data-aria') || '') : '';
    var visible = false, survol = false, doigt = false, focus = false, demande = false, editeur = false;

    function nom(i) { var t = ds[i].querySelector('.pbg-diapo__nom'); return t ? t.textContent.replace(/\s+/g, ' ').trim() : ''; }
    function img(i) { return ds[(i + N) % N].querySelector('img'); }
    /* pied fixe : le prix passe en fondu croisé (les deux couches changent d'opacité en même temps, même courbe : cumul constant = 1, aucun trou) ;
       le lien et le libellé accessible du bouton changent quand le nouveau visuel devient majoritaire. */
    function prixVers(i) {
      couches.forEach(function (c, k) {
        var on = k === i;
        c.classList.toggle('est-on', on);
        if (on) c.removeAttribute('aria-hidden'); else c.setAttribute('aria-hidden', 'true');
      });
    }
    function lienVers(i) {
      if (!cta) return;
      var a = ds[i].querySelector('a');
      if (a) cta.setAttribute('href', a.getAttribute('href'));
      cta.setAttribute('aria-label', (ariaCta + ' ' + nom(i)).trim());
    }

    /* segments (un par visuel, nommés pour les lecteurs d'écran) */
    var segs = ds.map(function (s, i) {
      s.setAttribute('aria-label', (i + 1) + (en ? ' of ' : ' sur ') + N);
      if (i !== cur) { s.setAttribute('aria-hidden', 'true'); s.inert = true; }
      var b = d.createElement('button');
      b.type = 'button'; b.className = 'pbg-diapo__seg';
      b.setAttribute('aria-label', nom(i) + ' (' + (i + 1) + '/' + N + ')');
      b.innerHTML = '<span class="pbg-diapo__seg-plein"></span>';
      b.addEventListener('click', function () { allerPret(i, i < cur ? -1 : 1); });
      if (boite) boite.appendChild(b);
      return b;
    });
    if (N < 2) { el.classList.add('est-seul'); return; }

    function majSegs() {
      segs.forEach(function (b, k) {
        b.classList.toggle('est-vu', k < cur);
        b.classList.toggle('est-courant', k === cur);
        if (k === cur) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      if (compte) compte.textContent = deux(cur + 1);
    }
    function majPause() {
      var p = !visible || d.hidden || survol || doigt || focus || demande || editeur;
      el.classList.toggle('en-pause', p);
      if (annonce) annonce.setAttribute('aria-live', (reduit || demande || focus) ? 'polite' : 'off');
    }
    /* le segment en cours se remplit ; à la fin, le visuel suivant */
    function remplir() {
      if (reduit) return;
      var b = segs[cur];
      b.classList.remove('est-en-cours'); void b.offsetWidth; b.classList.add('est-en-cours');
    }
    segs.forEach(function (b, k) {
      b.firstChild.addEventListener('animationend', function () { if (k === cur && !sortant) allerPret(cur + 1, 1); });
    });
    function precharger(i) {
      [i + 1, i - 1].forEach(function (k) { var m = img(k); if (m && m.loading === 'lazy') m.loading = 'eager'; });
    }
    function retirerMoities() { if (moities && moities.parentNode) moities.parentNode.removeChild(moities); moities = null; }
    /* ouverture du coffret : deux copies de l'image de l'ancien visuel, chacune dans une demi-fenêtre (overflow hidden) ; l'état du zoom lent est repris tel quel */
    function fendre(a) {
      var cadre = a.querySelector('.pbg-diapo__cadre'), im = a.querySelector('img');
      if (!cadre) return;
      var t = im ? getComputedStyle(im).transform : 'none';
      moities = d.createElement('span'); moities.className = 'pbg-diapo__moities'; moities.setAttribute('aria-hidden', 'true');
      ['g', 'd'].forEach(function (cote) {
        var m = d.createElement('span'); m.className = 'pbg-diapo__moitie pbg-diapo__moitie--' + cote;
        var c = cadre.cloneNode(true);
        [].forEach.call(c.querySelectorAll('[id]'), function (x) { x.removeAttribute('id'); });
        var ci = c.querySelector('img'); if (ci) { ci.removeAttribute('loading'); ci.style.animation = 'none'; if (t && t !== 'none') ci.style.transform = t; }
        m.appendChild(c); moities.appendChild(m);
      });
      a.appendChild(moities);
    }
    function terminer() {
      clearTimeout(minuterie); minuterie = 0;
      clearTimeout(tMilieu); clearTimeout(tPrix); tMilieu = 0; tPrix = 0;
      prixVers(cur); lienVers(cur); retirerMoities();
      if (sortant) { sortant.classList.remove('est-sortant'); sortant = null; }
      if (entrant) { entrant.classList.remove('est-entrant'); entrant = null; }
      el.classList.remove('fx-fondu', 'fx-rideau', 'fx-ouverture', 'sens-g');
      remplir();
    }
    function aller(i, sens) {
      i = (i + N) % N;
      if (i === cur) return;
      if (sortant || entrant) terminer();
      var a = ds[cur], b = ds[i];
      var avaitFocus = a.contains(d.activeElement);
      var fx = reduit ? '' : EFFETS[nb++ % EFFETS.length];
      if (fx === 'ouverture') fendre(a);   /* avant de retirer est-actif : le zoom lent de l'image est lu tant qu'elle est affichée */
      segs[cur].classList.remove('est-en-cours');
      cur = i;
      b.inert = false; b.removeAttribute('aria-hidden');
      /* classes posées dans le même passage de style : l'ancien visuel ne passe jamais par « masqué » (son zoom lent ne repart pas de 1) */
      if (!reduit) {
        el.classList.add('fx-' + fx);
        if (sens < 0) el.classList.add('sens-g');
        a.classList.add('est-sortant'); sortant = a;
        b.classList.add('est-entrant'); entrant = b;
        tPrix = setTimeout(function () { prixVers(cur); }, Math.round(TRANS * 0.35));
        tMilieu = setTimeout(function () { lienVers(cur); }, Math.round(TRANS * 0.5));
      }
      a.classList.remove('est-actif');
      b.classList.add('est-actif');
      if (avaitFocus) { var l = b.querySelector('a'); if (l) l.focus({ preventScroll: true }); }
      a.setAttribute('aria-hidden', 'true'); a.inert = true;
      majSegs(); precharger(i);
      if (annonce) annonce.textContent = nom(i) + ', ' + (i + 1) + (en ? ' of ' : ' sur ') + N;
      if (reduit) { prixVers(cur); lienVers(cur); return; }
      minuterie = setTimeout(terminer, TRANS + 40);
    }
    /* n'entrer qu'avec une image chargée et décodée (aucun blanc) ; image cassée = visuel sauté */
    function allerPret(i, sens) {
      i = (i + N) % N;
      var m = img(i), t = ++jeton;
      if (!m) return aller(i, sens);
      if (m.loading === 'lazy') m.loading = 'eager';
      function go() { if (t === jeton) aller(i, sens); }
      function pret() { if (m.decode) m.decode().then(go, go); else go(); }
      if (m.complete && m.naturalWidth) return pret();
      if (m.complete && !m.naturalWidth && m.currentSrc) { if (t === jeton) allerPret(i + (sens < 0 ? -1 : 1), sens); return; }
      m.addEventListener('load', pret, { once: true });
      m.addEventListener('error', function () { if (t === jeton) allerPret(i + (sens < 0 ? -1 : 1), sens); }, { once: true });
    }

    /* souris : pause au survol */
    el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { survol = true; majPause(); } });
    el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { survol = false; majPause(); } });
    /* doigt : posé = pause ; balayage horizontal = suivant / précédent ; un balayage n'ouvre pas la fiche */
    var pid = null, x0 = 0, y0 = 0, dx = 0, glisse = false, tPose = 0, long = false;
    piste.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      pid = e.pointerId; x0 = e.clientX; y0 = e.clientY; dx = 0; glisse = false; long = false; tPose = e.timeStamp;
      doigt = true; majPause();
    }, { passive: true });
    piste.addEventListener('pointermove', function (e) {
      if (e.pointerId !== pid) return;
      dx = e.clientX - x0;
      if (!glisse && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(e.clientY - y0) * 1.2) glisse = true;
    }, { passive: true });
    function lacher(e, annule) {
      if (e.pointerId !== pid) return;
      pid = null; doigt = false;
      long = !glisse && e.timeStamp - tPose > 450;   /* toucher prolongé = pause seulement : il n'ouvre pas la fiche */
      if (!annule && glisse && Math.abs(dx) > 40) allerPret(cur + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      majPause();
    }
    piste.addEventListener('pointerup', function (e) { lacher(e, false); });
    piste.addEventListener('pointercancel', function (e) { lacher(e, true); });
    piste.addEventListener('click', function (e) { if (glisse || long) { e.preventDefault(); e.stopPropagation(); glisse = false; long = false; } }, true);
    piste.addEventListener('contextmenu', function (e) { if (e.pointerType && e.pointerType !== 'mouse') e.preventDefault(); });
    piste.addEventListener('dragstart', function (e) { e.preventDefault(); });
    /* clavier : ← → ; focus clavier dans le diaporama = pause */
    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        var s = e.key === 'ArrowRight' ? 1 : -1;
        var surSeg = e.target.classList && e.target.classList.contains('pbg-diapo__seg');
        allerPret(cur + s, s);
        if (surSeg) { var k = (cur + s + N) % N; segs[k].focus(); }
      }
    });
    el.addEventListener('focusin', function (e) {
      var fv = true; try { fv = e.target.matches(':focus-visible'); } catch (_) {}
      if (fv) { focus = true; majPause(); }
    });
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) { focus = false; majPause(); } });
    /* bouton ‖ / ▶ */
    if (bouton) bouton.addEventListener('click', function () {
      demande = !demande;
      bouton.setAttribute('aria-pressed', demande ? 'true' : 'false');
      var sr = bouton.querySelector('.pbg-sr'); if (sr) sr.textContent = demande ? bouton.getAttribute('data-lire') : bouton.getAttribute('data-pause');
      majPause();
    });
    /* boutons ronds précédent / suivant (identiques au bouton ‖ : même relief ; cibles de 44 px, équivalent des segments fins, WCAG 2.5.8) */
    var bp = racine.querySelector('[data-pbg-diapo-prec]'), bs = racine.querySelector('[data-pbg-diapo-suiv]');
    if (bp) bp.addEventListener('click', function () { allerPret(cur - 1, -1); });
    if (bs) bs.addEventListener('click', function () { allerPret(cur + 1, 1); });
    /* à l'écran (au moins 35 % du diaporama), onglet affiché */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en_) {
        var e = en_[en_.length - 1];
        visible = e.isIntersecting && e.intersectionRatio >= 0.35;
        if (e.isIntersecting) precharger(cur);
        majPause();
      }, { threshold: [0, 0.35, 0.6] }).observe(el);
    } else { visible = true; }
    d.addEventListener('visibilitychange', majPause);
    /* éditeur de thème : le bloc choisi s'affiche et le diaporama s'arrête */
    d.addEventListener('shopify:block:select', function (e) {
      var k = ds.indexOf(e.target); if (k < 0) return;
      editeur = true; majPause(); aller(k, k < cur ? -1 : 1);
    });
    d.addEventListener('shopify:block:deselect', function (e) { if (ds.indexOf(e.target) >= 0) { editeur = false; majPause(); } });

    majPause(); majSegs(); prixVers(cur); lienVers(cur); remplir();
    el.classList.add('est-pret');
  }

  function init() { [].forEach.call(d.querySelectorAll('[data-pbg-diapo]'), diapo); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', init);
})();
